<div class="dashboard-doorstroom">
	<section class="dashboard">
		<app-dashboard-header>
			<app-legenda class="cl-header-utility" [attribute]="['ds_nm_idu']" [includeNull]="true"></app-legenda>
		</app-dashboard-header>
		<div class="scrollport">
			<div class="dummy"></div>
			<div #anchor class="anchor"></div>
			<div class="paths">
				@for (path of paths(); track path) {
					<app-doorstroom-path [path]="path" data-exportable></app-doorstroom-path>
				}
			</div>
		</div>
	</section>
</div>
